// src/features/document/canEdit.ts
// Auto-generated by corebuilder. Edit freely.

/**
 * Permission check for editing a document.
 * Only draft or revision documents can be edited.
 */
export function canEditDocument(item: { status?: string }): boolean {
  return (
    item.status === 'DOCUMENT_STATUS_DRAFT' ||
    item.status === 'DOCUMENT_STATUS_REVISION'
  );
}
